import React from 'react'
import { LazyLoadImage } from "react-lazy-load-image-component";

export default function PhotoCard(props) {
  return (
      <div className="w-44 rounded overflow-hidden shadow-lg bg-gray-800 m-2" style={{width:'18rem'}}>
          <LazyLoadImage src={`https://api.pepsi.pics/pespi/${props.name}`}
            className="w-full"
            alt="Pepsi pic"
            placeholder={<p>Loading image...</p>}
          />
          <div className="px-6 py-4">
            <div className="font-bold text-xl mb-2 text-white">{props.name}</div>
            <a href={`https://api.pepsi.pics/pespi/${props.name}`} target='_blank' rel="noreferrer" className="text-green-500 inline-block mt-2">Link to picture</a>
          </div>
      </div>
  )
}
//<div className="font-italic text-sm mb-2 text-gray-300">{props.seen} views</div>